var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 420.1 412.7",
    style: {
      enableBackground: "new 0 0 420.1 412.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FBF4E4;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M420.1,202.7c-0.3,43.7-10.1,81.9-33,115.9c-35.1,52.1-83.8,84-146.3,92c-78.4,10.1-144.1-15-195.3-75.7 C20.7,305.7,6.3,271.4,1.7,233.4c-6.9-57.9,7.4-110.2,44.1-155.6c32.7-40.6,75.9-64.2,126.7-74.1C257.6-12.9,348,28,392,102.7 C410.6,134.4,419.8,168.8,420.1,202.7L420.1,202.7z M212.3,37.5c-7.5,0.7-17.8,1-27.8,2.6C132,48.2,91.1,74.6,62.6,119.4 c-22,34.5-29,72.7-22.8,112.8c7.5,48.4,32,86.8,73,113.9c41,27.2,86.3,36.2,134.2,25.5c61.2-13.7,104.5-50,125.8-109.5 c17.5-48.9,12.3-96.8-14.7-141.2C325.8,67.5,276.9,41.3,212.3,37.5L212.3,37.5L212.3,37.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M290,205.1c-7-11-20.8-12.2-30.2-2.6c-8.5,8.6-17.1,17.2-25.6,25.8c-0.6,0.6-1.3,1.2-2.5,2.2v-95.2l0,0 c0-5.9,0-11.8-0.1-17.7c-0.1-8.4-4.2-14.7-11.6-18.5c-7.4-3.8-14.9-3.1-21.8,1.6c-6.6,4.4-9.2,11-9.2,18.7v16.4l0,0v41.8l0,0v53.1 c-1.2-1-1.7-1.5-2.2-1.9c-5.7-5.7-11.3-11.5-17-17.1c-4.3-4.2-8.4-8.7-13.2-12.3c-7.4-5.7-18-3.9-24.2,3.5 c-6.1,7.2-5.6,16.8,1.2,23.6c18.5,18.6,37.1,37.2,55.6,55.8c3.5,3.5,6.9,7.2,10.8,10.3c2.1,1.7,4.8,2.9,7.5,3.4 c6.2,1.3,11.3-1.1,15.7-5.4c14.3-14.2,28.6-28.5,42.8-42.7c7.3-7.3,14.5-14.6,21.7-22C293.3,219.8,294.2,211.7,290,205.1L290,205.1 L290,205.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown2);
export default __webpack_public_path__ + "static/media/arrowDown2.3a146a939984808aaac541188b79b23c.svg";
export { ForwardRef as ReactComponent };